/**
 * Изолированный контекст данных новости задаётся `moduleSlug` в API как произвольная строка:
 * у кастомных модулей проекта свой слаг (создание модуля → строка на фронте).
 * GraphQL не фиксирует enum поэтому — здесь перечислены только встроенные (известные) слаги.
 * Значения должны совпадать с бэкендом.
 */
export enum NewsModuleSlugEnum {
  Entertainment = 'entertainment',
  ProjectNews = 'project_news',
  ConsumerRights = 'consumer_rights',
  AccidentGuidance = 'accident_guidance',
  MySpeech = 'my_speech',
}
